import { render, staticRenderFns } from "./surface.vue?vue&type=template&id=37b8f09e&scoped=true&"
import script from "./surface.vue?vue&type=script&lang=js&"
export * from "./surface.vue?vue&type=script&lang=js&"
import style0 from "./surface.vue?vue&type=style&index=0&id=37b8f09e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b8f09e",
  null
  
)

export default component.exports